package ru.villawonka.app.uaparser

import ru.villawonka.app.platform.platform.model.DeviceInfo

class UAParser {
    companion object {
        fun parse(userAgent: String): DeviceInfo {
            val deviceRegex = """(iPhone|iPad|Android|Windows Phone|Windows|Macintosh|Linux)""".toRegex()
            val platformRegex = """(Windows NT|Mac OS X|Android|iOS) (\d+[_\.]\d+)""".toRegex()

            val deviceMatch = deviceRegex.find(userAgent)
            val platformMatch = platformRegex.find(userAgent)

            return DeviceInfo(
                deviceName = deviceMatch?.groupValues?.get(1),
                osName = platformMatch?.groupValues?.get(1),
                osVersion = platformMatch?.groupValues?.get(2)?.replace("_", ".")
            )
        }
    }
}